import React, {Component} from 'react'
import {ToggleButton} from './switch';
import AddressInput from './addressinput';
import BookingInput from './bookinginput';
import { ajaxerrmsg, RZPay } from '../../actions/http';
import {connect} from "react-redux";
import {bookNow, clearPos, closeModal, openModal, clearImagePreview, bookOnline, getMasterValues, clearOrder, clearCoupon, addToast, updateInsAmt} from "../../actions";
import { ErrorBox } from '../listing';
import Placemarker from './placemarker';
import ButtonLoader from '../btnloader';

const addr_keys = ["pin_code", "name", "mobile"];
const item_keys = ["weight", "height", "length", "depth"];

class BookinPage extends Component{

    constructor(props){
        super(props);
        this.state = {
            pickup: ['', '', ''],
            drop: ['', '', ''],
            item: ['', '', '', ''],
            pickup_err: ['', '', ''],
            drop_err: ['', '', ''], 
            item_err: ['', '', '', ''],
            product_items: props.productItems || [],
            productfetching: false,
            payment_type: 2,
            is_pick_me: true,
            pickup_address_err: false,
            drop_address_err: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDonation = this.handleDonation.bind(this);
        this.handleInsurance = this.handleInsurance.bind(this);
        this.itemClick = this.itemClick.bind(this);
        this.pickMe = this.pickMe.bind(this);
        this.setErr = this.setErr.bind(this);
    }

    componentWillMount(){
        console.log(this.props);
        let {user} = this.props;
        if(user.token){
            this.setState({
                pickup: ['', user.first_name || '', user.username || '']
            })
        }
        this.props.updateInsAmt({donation: this.props.donAmt, insurance: this.props.insAmt});
    }

    handleChange(e){
        let {name, value} = e.target;
        name = name.split("_");
        let item = name[0];
        let index = parseInt(name[1], 10);
        this.setState(prevState => {
            let prev = prevState[item];
            let prev_err = prevState[item + "_err"];
            prev[index] = value;
            prev_err[index] = '';
            return {
                [item]: prev,
                [item + "_err"]: prev_err
            }
        })
    }

    setErr(type, index, errtxt){
        this.setState(prevState => {
            let prev_err = prevState[type + "_err"];
            prev_err[index] = errtxt;
            return {
                [type + "_err"]: prev_err
            }
        })
    }

    itemClick(id, active){
        this.setState(prevState => {
            return {
                product_items: prevState.product_items.map(x => {
                    if(x.id === id){
                        return {...x, active}
                    }
                    return x
                })
            }
        })
    }

    pickMe(){
        this.setState(prevState => ({
            is_pick_me: !prevState.is_pick_me
        }))
    }

    checkdetails(type){
        let detail = this.state[type];
        if(detail[0].length < 6){
            this.setErr(type, 0, "Pincode is invalid");
            return false;
        }
        if(!phonevalid(detail[2]) ){
            this.setErr(type, 2, "Contact number is invalid");
            return false;
        }
        return true;
    }

    createdetails(data, keys, type){
        let detail = {};
        keys.forEach((key, index) => {
            detail[key] = data[index];
        });
        if(type){
            let { lat, lng } = this.props[type + "_pos"];
            let address = this.props[type + "_address"];
            detail.latitude = lat.toFixed(5);
            detail.longitude = lng.toFixed(5);
            detail.address = address;
        }
        return JSON.stringify(detail);
    }

    handleSubmit(e){
        e.preventDefault();
        this.postFormData();
    }

    termsbtn(head, id) {
        return (
            // eslint-disable-next-line
            <a 
                className="pointer"
                onClick={() => this.props.openModal("TERMS_MODAL", {master_id: id, modalHeading:`${head} Terms & Conditions`})} 
            >
                T&C
            </a>
        )
    }

    postFormData(){
        let { pickup_address, drop_address, user, openModal, offer_code, addToast} = this.props;
        if(!pickup_address){
            this.setState({pickup_address_err: true});
            return;
        }
        if( ! this.checkdetails("pickup") ){
            return;
        }
        if(!drop_address){
            this.setState({drop_address_err: true});
            return;
        }
        if(!this.state.is_pick_me){
            if( ! this.checkdetails("drop") ){
                return;
            }
        } else if(this.state.drop[0].length < 6){
            this.setErr("drop", 0, "Pincode is invalid");
            return false;
        }
        if(this.state.payment_type === 1){
            addToast("Online payment not yet available", false);
            return;
        }
        if(!user.token){
            openModal("LOG_IN");
            return;
        }
        if(!this.props.user.is_profile){
            this.props.openModal('UPDATE_PROFILE');
            return;
        }
        let formData = new FormData();
        let {pickup, drop, item, product_items, payment_type, is_pick_me} = this.state;
        let pickupdetails = this.createdetails(pickup, addr_keys, "pickup");
        formData.append("pickupdetails", pickupdetails);
        if(!is_pick_me){
            let deliverydetails = this.createdetails(drop, addr_keys, "drop");
            formData.append("deliverydetails", deliverydetails);
            let items_id = product_items.filter(item => item.active === true).map(x => x.id);
            formData.append("items_id", JSON.stringify(items_id));
            item_keys.forEach((key, index) => {
                if(item[index]){
                    formData.append(key, item[index]);
                }
            })
            let images = this.props.images;
            if(images.length > 0){
                for(let i = 0; i < images.length; i++){
                    formData.append("image", images[i].file);
                }
            }
        } else {
            let new_drop =  [drop[0], pickup[1], pickup[2]];
            let deliverydetails = this.createdetails(new_drop, addr_keys, "drop");
            formData.append("deliverydetails", deliverydetails);
            formData.append("is_pick_me", is_pick_me ? 1 : 0);
        }
        formData.append("payment_type", payment_type);
        formData.append("is_insurance", this.props.insurance ? 1 : 0);
        formData.append("is_donations", this.props.donation ? 1 : 0);
        if(offer_code.id) {formData.append("offer_code", offer_code.id)}
        this.props.bookNow(formData);
    }

    isarrempty(arr){
        return arr.filter(x => x.length !== 0).length === arr.length
    }

    checkdrop(){
        let { drop, is_pick_me } = this.state;
        if(is_pick_me){
            return drop[0].length > 0
        } else {
            let cond = this.isarrempty(drop);
            return cond;
        }
    }

    checkinputs(){
        let { pickup, product_items, is_pick_me } = this.state;
        return this.isarrempty(pickup) && this.checkdrop() &&
        (is_pick_me || product_items.filter(x => x.active === true).length > 0);
    }

    handleDonation(e){
        const { checked } = e.target;
        this.props.updateInsAmt({donation: checked ? this.props.donAmt : 0});
    }

    handleInsurance(e){
        const { checked } = e.target;
        this.props.updateInsAmt({insurance: checked ? this.props.insAmt : 0});
    }

    render() {
        let { pickup, drop, item, pickup_err, drop_err, item_err, product_items, payment_type, is_pick_me, pickup_address_err, drop_address_err} = this.state;
        return (
            <form className="form-horizontal" onSubmit={this.handleSubmit} noValidate autoComplete="off">
                <fieldset>
                    <div className="flex-between">
                        <h4>Pickup details</h4>
                        <Placemarker />
                    </div>
                    <div className="row">
                        <AddressInput type="P" err={pickup_address_err} />
                        <BookingInput type="number" maxLength="6" onChange={this.handleChange} value={pickup[0]} err={pickup_err[0]} name="pickup_0" placeholder="Pincode *"/>
                        <BookingInput onChange={this.handleChange} value={pickup[1]} err={pickup_err[1]} name="pickup_1" placeholder="Contact name *"/>
                        <BookingInput onChange={this.handleChange} value={pickup[2]}  err={pickup_err[2]} name="pickup_2" placeholder="Contact number *" type="number" maxLength="10"/>     
                    </div>
                </fieldset>
                <fieldset>
                    <h4>Drop details</h4>
                    <div className="row">
                        <AddressInput type="D" err={drop_address_err} />
                        <BookingInput type="number" maxLength="6" onChange={this.handleChange} value={drop[0]} err={drop_err[0]}  name="drop_0" placeholder="Pincode *"/>
                        {!is_pick_me && <BookingInput 
                            onChange={this.handleChange} 
                            value={drop[1]} 
                            err={drop_err[1]} 
                            name="drop_1" 
                            placeholder="Contact name *"
                        />}
                        {!is_pick_me && <BookingInput 
                            onChange={this.handleChange} 
                            value={drop[2]} 
                            err={drop_err[2]} 
                            name="drop_2" 
                            placeholder="Contact number *" 
                            type="number" 
                            maxLength="10"
                        />}
                    </div>
                </fieldset>
                <fieldset>
                    <div className="flex-between">
                        <h4>Item details</h4>
                        <ToggleButton checked={is_pick_me} onChange={this.pickMe}/>
                    </div>
                    {!is_pick_me &&
                    <div className="row">
                        <div className="col-md-12">
                            <ul className="typelist list-inline list-unstyled">     
                            {
                                product_items.map(item => 
                                    <li 
                                        className={item.active ? 'active' : ''}
                                        key={item.id} 
                                        onClick={() => this.itemClick(item.id, !item.active)} 
                                    >
                                        {item.name}
                                    </li>
                                )
                            }    
                            </ul>
                        </div>
                        <BookingInput onChange={this.handleChange} value={item[0]} err={item_err[0]} size="3" name="item_0" placeholder="Weight(kgs)" type="number"/> 
                        <BookingInput onChange={this.handleChange} value={item[1]} err={item_err[1]}  size="3" name="item_1" placeholder="Height (cm)" type="number"/> 
                        <BookingInput onChange={this.handleChange} value={item[2]} err={item_err[2]} size="3" name="item_2" placeholder="Width (cm)" type="number"/> 
                        <BookingInput onChange={this.handleChange} value={item[3]} err={item_err[3]}  size="3" name="item_3" placeholder="Depth (cm)" type="number"/> 
                        <div className="col-md-12">
                            <label className="file-upload" onClick={() => this.props.openModal('IMAGE_PREVIEW')}>
                                <i className="fas fa-camera-retro"></i> Photos
                                <span className="m-l-1"> {this.props.images.length || ''}</span>
                            </label>
                        </div>                            
                    </div>}
                </fieldset>
                <fieldset>
                    <div className="flex-between">
                        <h4>Payment details</h4>            
                        <div 
                            className="btn btn-link" 
                            onClick={() => this.props.openModal("RATE_CARD")}
                        >
                            View Rate Card
                        </div>
                    </div>    
                    <div className="row">   
                        <div className="col-md-4">
                            <label className="file-upload f14" onClick={() => this.props.openModal('OFFERS')}>
                                {this.props.offer_code.code ? this.props.offer_code.code  + " Applied" : 'Apply Coupon' }
                            </label>
                        </div>                                 
                        <div className="col-md-8 togglecontainer">
                            <label 
                                onClick={() => this.setState({payment_type: 1})}
                                className={`togglelabel leftborderadius flex-center ${payment_type === 1 ?"togglelabelactive" : ""}`}
                            >
                                Online
                            </label>
                            <label 
                                onClick={() => this.setState({payment_type: 2})}
                                className={`togglelabel  flex-center ${payment_type === 2 ?"togglelabelactive" : ""}`}
                            >
                                COD
                            </label>
                            <label 
                                onClick={() => this.setState({payment_type: 3})}
                                className={`togglelabel rightborderadius flex-center ${payment_type === 3 ?"togglelabelactive" : ""}`}
                            >
                                CARD
                            </label>
                        </div>
                    </div>
                    <div className="row m-b-10">
                        <div className="col-md-12">
                            <div className="tickbox">
                                <input type="checkbox" id="insurance" 
                                checked={this.props.insurance ? true : false}
                                onChange={this.handleInsurance} />
                                <label htmlFor="insurance"></label>
                                <span 
                                    className="checkinlabel"
                                >
                                    Add &#8377;{this.props.insAmt} as  insurance for this transaction {this.termsbtn("Insurance", 6)}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row m-b-15">
                        <div className="col-md-12">
                            <div className="tickbox">
                                <input type="checkbox" id="donation" 
                                checked={this.props.donation ? true : false}
                                onChange={this.handleDonation} />
                                <label htmlFor="donation"></label>
                                <span className="checkinlabel">Add &#8377;{this.props.donAmt} as donation towards Ouja Welfare Trust {this.termsbtn("Donation", 6)}
                                </span>
                            </div>
                        </div>
                    </div>
                </fieldset>
                {
                    this.props.createOrder.error &&
                    <ErrorBox errmsg={ajaxerrmsg(this.props.createOrder.error)} />
                }
                <div className="row m-b-10">
                    <div className="col-md-12">        
                        <button 
                            disabled={ this.checkinputs() && !this.props.createOrder.fetching ? false : true} 
                            type='submit' 
                            onSubmit={this.handleSubmit} 
                            className="btn btn-raised legitRipple bookbtn"
                        >
                            {this.props.createOrder.fetching ? <ButtonLoader /> : 'Book now' }
                        </button>
                    </div>
                </div>
            </form>
        )
    }
    
    componentDidUpdate(prevProps){
        let { createOrder, user, bookOnline, closeModal} = this.props;
        let order = createOrder.data;
        //after login
        if(user.token && !prevProps.user.token){
            closeModal();
            this.postFormData();
        }
        //after updating user
        if(this.props.user.is_profile && this.props.user.is_profile !== prevProps.user.is_profile){
            if(this.checkinputs()){
                this.postFormData();
            }
        }
        //after order placed
        if(order && !prevProps.createOrder.data){
            //Check if order is online payment and call razorpay
            if(this.state.payment_type === 1 && order.razorpay_order_id){
                RZPay(order, user, bookOnline);
            } else {
                this.props.history.push("/orders");
            }
        }
    }

    componentWillUnmount(){
        this.props.clearImagePreview();
        this.props.clearPos();
        this.props.clearOrder();
        this.props.clearCoupon();
        this.props.updateInsAmt({donation: 0, insurance: 0});
    }
} 

export const phonevalid = val => {
    var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return re.test(val);
}

const mapStateToProps = ({bookingLoc, createOrder, imagePreview, loginReducer ,coupon, insAmt}) => ({
    pickup_pos: bookingLoc.pickup,
    drop_pos: bookingLoc.drop,
    pickup_address: bookingLoc.pickupAddress,
    drop_address: bookingLoc.dropAddress,
    createOrder,
    images: imagePreview,
    user: loginReducer.data,
    offer_code: coupon,
    insurance: insAmt.insurance,
    donation: insAmt.donation
})

const mapDispatchToProps = { bookNow, clearPos, openModal, clearImagePreview, bookOnline, getMasterValues,  clearOrder, closeModal, clearCoupon, addToast, updateInsAmt };

export default connect(mapStateToProps, mapDispatchToProps)(BookinPage)
